import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { api } from "@/lib/api";
import { LEGAL_VERSION } from "@/pages/LegalPages";

const read = () => {
  try { return JSON.parse(localStorage.getItem("cs_consent") || "null"); } catch { return null; }
};
const visitor = () => {
  let id = localStorage.getItem("cs_visitor");
  if (!id) { id = crypto.randomUUID(); localStorage.setItem("cs_visitor", id); }
  return id;
};

export const openConsent = () => window.dispatchEvent(new Event("cs-open-consent"));

const LINKS = [["/privacy", "Privacy", "privacy"], ["/cookie", "Cookie policy", "cookie"], ["/condizioni-di-vendita", "Condizioni di vendita", "terms"], ["/note-legali", "Note legali", "notes"]];

export const ConsentGate = () => {
  const [seen, setSeen] = useState(() => read()?.version === LEGAL_VERSION);
  useEffect(() => {
    const h = () => setSeen(false);
    window.addEventListener("cs-open-consent", h);
    return () => window.removeEventListener("cs-open-consent", h);
  }, []);
  if (seen) return null;
  const close = () => {
    localStorage.setItem("cs_consent", JSON.stringify({ version: LEGAL_VERSION, choice: "necessari", at: new Date().toISOString() }));
    api.post("/consents", { visitor_id: visitor(), version: LEGAL_VERSION, choice: "necessari" }).catch(() => {});
    setSeen(true);
  };
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-16 z-[60] flex justify-center px-3 md:bottom-4" data-testid="consent-gate">
      <div role="region" aria-label="Informativa cookie" className="pointer-events-auto flex w-full max-w-3xl items-start gap-3 rounded-2xl border border-black/10 bg-white/95 p-4 text-sm shadow-xl backdrop-blur-md animate-in fade-in slide-in-from-bottom-4">
        <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
        <div className="min-w-0 flex-1">
          <p className="text-stone-700"><span className="hidden sm:inline">Usiamo solo <b>cookie tecnici</b> necessari al funzionamento del sito (carrello, accesso, lingua). Nessuna profilazione o pubblicità.</span><span className="sm:hidden">Solo <b>cookie tecnici</b>, nessuna profilazione.</span></p>
          <p className="mt-1 flex flex-wrap gap-x-3 gap-y-0.5 text-[11px] sm:text-xs">
            {LINKS.map(([to, l, id]) => <Link key={to} to={to} className="font-semibold text-cyan-700 underline" data-testid={`consent-link-${id}`}>{l}</Link>)}
          </p>
        </div>
        <button onClick={close} className="shrink-0 rounded-full bg-black px-4 py-2 text-xs font-bold text-white transition-colors hover:bg-stone-800" data-testid="consent-accept">Ok, ho capito</button>
        <button onClick={close} aria-label="Chiudi" className="hidden shrink-0 rounded-full p-1.5 text-stone-500 hover:bg-black/5 sm:block" data-testid="consent-close"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
};
